import type { AdminAccount, Section } from '../../types'
import { REDIRECT_QUERY_PARAM, normalizeRedirectTarget } from './redirectTarget'
import { resolveSectionFromLocation } from './sectionRouting'

const isCustomerOnlyAccount = (account: AdminAccount | null) =>
  account?.roles?.includes('customer') === true &&
  !account.roles.some((role) => role === 'admin' || role === 'super-admin' || role === 'site-manager')

export const applyAdminPostLoginRouting = ({
  account,
  setSection,
  resolveSectionFromUrl,
}: {
  account: AdminAccount | null
  setSection: (section: Section) => void
  resolveSectionFromUrl: () => Section | null
}) => {
  const fallbackSection: Section = 'dashboard'

  if (isCustomerOnlyAccount(account)) {
    if (typeof window !== 'undefined') {
      window.location.replace('/dashboard')
    }
    return
  }

  const redirectParam =
    typeof window !== 'undefined'
      ? new URLSearchParams(window.location.search).get(REDIRECT_QUERY_PARAM)
      : null
  const redirectTarget =
    typeof window !== 'undefined'
      ? normalizeRedirectTarget(redirectParam, window.location.origin)
      : null

  if (redirectTarget && typeof window !== 'undefined') {
    const redirectUrl = new URL(redirectTarget, window.location.origin)
    const redirectSection =
      resolveSectionFromLocation(redirectUrl.search, redirectUrl.hash, redirectUrl.pathname) ||
      fallbackSection

    window.history.replaceState({}, '', redirectTarget)
    setSection(redirectSection)
    return
  }

  setSection(resolveSectionFromUrl() || fallbackSection)
}
